import { fetchServiceDocuments } from '../../../../api/actions/serviceDocuments';
import { CHECKOUT_DOCUMENT_TYPES } from '../../../../constants';
import { getEnterpriseServiceId } from '../../../../modules/entities/services/selectors';
import { getSelectedHotelId } from '../../../../modules/resourceOrder/selectors';
import { DistributorThunkAction } from '../../../../types';

export const fetchCheckoutDocuments = (): DistributorThunkAction => async (dispatch, getState) => {
    const state = getState();
    const enterpriseId = getSelectedHotelId(state);

    const serviceId = enterpriseId != null ? getEnterpriseServiceId(state, { enterpriseId }) : null;

    if (serviceId == null) {
        return;
    }

    await dispatch(
        fetchServiceDocuments({
            serviceIds: [serviceId],
            types: CHECKOUT_DOCUMENT_TYPES,
        })
    );
};

export const insertConfirmationStepState =
    (externalUrlWithReturnUrl: string): DistributorThunkAction =>
    (_dispatch, _getState, { historyService, environmentService }) => {
        const urlParams = new URLSearchParams(externalUrlWithReturnUrl);
        const optionalReturnUrl = urlParams.get('returnUrl');
        const envLocation = environmentService.get('location');

        if (optionalReturnUrl == null || envLocation == null) {
            return;
        }

        const returnUrl = new URL(window.atob(optionalReturnUrl), envLocation.href);
        if (returnUrl == null) {
            return;
        }

        if (returnUrl.origin === envLocation.origin) {
            historyService.pushState({ historyTracked: true }, returnUrl.href);
        } else {
            const returnUrlForWidget = new URL(envLocation.href);
            returnUrlForWidget.searchParams.set('mewsRedirect', returnUrl.href);
            historyService.pushState({ historyTracked: true }, returnUrlForWidget.href);
        }
    };
